import script from "./SocialAccounts.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialAccounts.vue?vue&type=script&setup=true&lang=js"

import "./SocialAccounts.vue?vue&type=style&index=0&id=1f151a0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f151a0a"]])

export default __exports__